import React from 'react';

export class CropperDescriptor {
    data: Object;
    imageData: Object;
    transform: {
        scale: number;
        translateX: number;
        translateY: number;
    };

    constructor(options: { data: Object, imageData: Object }) {

        const { data, imageData } = options;

        this.data = data;
        this.imageData = imageData;

        const { x, y, width, height, naturalWidth, naturalHeight } = {
            ...imageData,
            ...data,
        };

        const aspectRatio = width / height;

        this.transform = {
            scale: aspectRatio >= 1
                ? naturalWidth / width
                : naturalHeight / height,
            translateX: -1 * (x / naturalWidth) * 100,
            translateY: -1 * (y / naturalHeight) * 100,
        };

        this.transformOrigin = {
            x: (x / naturalWidth) * 100,
            y: (y / naturalHeight) * 100,
        };
    }
}

// $FlowWebpack
require('cropperjs/dist/cropper.css');
class CropperView extends React.PureComponent {
    static Cropper;

    cropper;

    onCrop = () => {
        if (this.props.onCrop) {
            this.props.onCrop(this.cropper);
        }

        this.forceUpdate();
    };

    setRef = ref => {
        this.cropper = ref;
    };

    componentDidMount() {
        if (!CropperView.Cropper) {
            CropperView.Cropper = require('react-cropper').default;
            this.forceUpdate();
        }
    }

    render() {
        const { Cropper } = CropperView;
        const { onCrop, ...rest } = this.props;

        if (Cropper) {
            return (
                <Cropper
                    ref={this.setRef}
                    style={{
                        height: '100%',
                        width: '100%',
                    }}
                    aspectRatio={16 / 9}
                    guides={true}
                    viewMode={1}
                    zoomable={false}
                    {...rest}
                    crop={this.onCrop}
                />
            );
        }

        return null;
    }
}

export default CropperView;
